
Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.SaveGridLayout = function () {

    this.layoutNameSpace = null;
    this.entity = null;
    this.selector = null;
    this.element = null;
    this.screenName = null;
    this.action = "index";

    this.setEntity = function (entity) {
        this.entity = entity;
    };

    this.setActionToGridLayout = function (action) {
        this.action = action;
    };

    this.setSelector = function (selector) {
        this.selector = selector;
    };

    this.setElement = function (element) {
        this.element = element;
    };

    this.setLayoutNameSpace = function (layout) {
        this.layoutNameSpace = layout;
    };

    this.setCallBacks = function (callbacks) {
        this.callbacks = callbacks;
    };

    this.setScreenName = function (screenName) {
        this.screenName = screenName;
    };

    this.checkElementAndWriteHTML = function (element, html) {

        if (element !== null) {
            $(element).append(html);
        }

    };

    var enableOrDisableButton = function (action, selector) {

        var button = null,
            error = null,
            isDisabled = false,
            attrDisabled = null;

        try {

            button = document.querySelector(selector + " #btnSaveLayout");

            if (button !== null) {

                if (action === "enable") {

                    attrDisabled = button.getAttribute("disabled");
                    isDisabled = attrDisabled === "disabled" || attrDisabled === "";

                    if (isDisabled) {
                        button.removeAttribute("disabled");
                    }

                } else {
                    button.setAttribute("disabled", "disabled");
                }

            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on enable or disable button", e);
            error.console();
        }

    }.bind(this);

    this.createLayout = function () {
        const translatedTitle = Monet.I18n.getResourcesByKey('Greenmile.Grid.Button.saveLayoutGrid');
        const btnValue = Monet.I18n.getResourcesByKey("Greenmile.Grid.Button.saveLayout");

        const btnHTML = `<div class="saveLayout gridActionDiv">
            <div class="spinner"></div>
            <input type="button" id="btnSaveLayout" class="button" disabled value="${btnValue}" title="${translatedTitle}"/>
        </div>`;
        
        this.checkElementAndWriteHTML(this.element, btnHTML);
    };

    this.addEventListeners = function () {

        var btn = this.element.querySelector(" #btnSaveLayout");
        var that = this;

        if (btn !== null) {

            btn.onclick = function () {
                this.disabled = true;
                this.classList && this.classList.toggle("loader-spinner");
                that.saveColumns();

            };

        }

    };

    this.getColumnsToSave = function () {

        var model = new App.Models.PageLayout();
        var collection = new App.Collections.PageLayout();
        var layout;
        var grid;
        var objToSave;
        var size = "";
        var columns = [],
            column = null,
            options = null,
            indexFrozen = -1;

        layout = App.Forms[this.screenName]['layout']['index'];
        grid = App.Forms[this.screenName]['table'];

        columns = grid.getColumns();
        options = grid.getOptions();

        indexFrozen = options.frozenColumn;

        if (typeof layout.models === "undefined") {

            model = new App.Models.PageLayout();
            model.set(layout);

            collection = new App.Collections.PageLayout();
            collection.add(model);

        } else {
            collection = layout;
        }

        objToSave = {
            id: collection.getSearchGridLayoutId(),
            userId: Monet.Session.User.id,
            searchGridColumns: []
        };

        for (var i = columns.length - 1; i >= 0; i--) {

            column = columns[i];

            if ((typeof column.fieldId !== "undefined" && typeof column.fieldId === "number")
                || (!objToSave.id && typeof column.fieldId === "string")) {

                const columnsIsNotFrozen = i > indexFrozen;
                const isFrozen = !columnsIsNotFrozen;

                var item = {
                    columnOrder: i,
                    field: {
                        id: column.fieldId
                    },
                    isAscendent: true,
                    isSorted: false,
                    isFrozen: isFrozen
                };

                size = column.width;

                if (size !== "") {
                    if (parseInt(size, 10) > 999) {
                        item.sizePixels = 999;
                    } else {
                        if (parseInt(size, 10) < 0) {
                            item.sizePixels = 100;
                        } else {
                            item.sizePixels = size;
                        }
                    }

                } else {
                    item.sizePixels = 100;
                }

                objToSave.searchGridColumns.push(item);

            }

        }

        return objToSave;

    };

    this.enableButtonToSave = function () {

        var error = null;

        try {

            enableOrDisableButton("enable", this.selector);

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on enable button to save.");
            error.console();
        }
    };

    this.saveColumns = function () {

        var requests = new Monet.Grid.ActionsModules.Requests(this.entity, null, this.screenName, this.action);
        requests.saveGridLayout(this.getColumnsToSave(this.entity), this.callbacks);

    };

    this.init = function () {

        if (typeof(this.screenName) === "undefined" || this.screenName === null) {
            this.screenName = Monet.Utils.GetTabName();
        }

        this.createLayout();
        this.addEventListeners();

    };

};